module.exports = __webpack_public_path__ + "static/media/Y_E_S_P_L_Z.e6846fe8.svg";